import { useNavigate } from 'react-router';
import { CheckHeavyAccent } from '#assets/ReactSvg.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { default as VipIllustration } from './vip.svg?react';

/**
 * {@link UpgradeSuccessModal} shows a confirmation after the user signs up for a paid plan.
 */
export function UpgradeSuccessModal() {
  const navigate = useNavigate();

  function returnToBillingPage() {
    void navigate('/settings/billing', { replace: true });
  }

  return (
    <Modal isOpen={true} onClose={returnToBillingPage}>
      <ModalHeader>Upgrade complete</ModalHeader>
      <ModalBody>
        <div className="flex justify-center">
          <VipIllustration width={240} height={240} />
        </div>
        <h3 className="h4">
          <CheckHeavyAccent /> Your account has been upgraded to Pro
        </h3>
        <ul className="ul">
          <li className="p">Enjoy priority support</li>
          <li className="p">Trust Managed Nebula’s guaranteed uptime</li>
          <li className="p">Create as many hosts, relays, and lighthouses as you like</li>
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button variant="primary" onClick={returnToBillingPage}>
          View account
        </Button>
      </ModalFooter>
    </Modal>
  );
}
